var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[(_vm.type)?_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c(_vm.mappingComponent[_vm.type],{tag:"component"})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }